import { UoReport, UoReportSearch } from '@/DTOS/UoReport/UoReport';
import request from '../../utils/request';

const UoReportService = {
  search: (search: UoReportSearch) => {
    return request('/uoReports/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  dashboard: (month: number, year: number) => {
    return request(`/uoReports/dashboard?month=${month}&year=${year}`, {
      method: 'GET',
    });
  },

  templates: () => {
    return request('/uoReports/templates', {
      method: 'GET',
    });
  },

  upsert: (report: UoReport) => {
    return request('/uoReports/upsert', {
      method: 'POST',
      body: JSON.stringify({ request: { ...report } }),
    });
  },

  sign: (id: string, technicianSignature?: string, beneficiarySignature?: string) => {
    return request('/uoReports/sign', {
      method: 'POST',
      body: JSON.stringify({ request: { id, technicianSignature, beneficiarySignature } }),
    });
  },

  markSent: (id: string) => {
    return request('/uoReports/mark-sent', {
      method: 'POST',
      body: JSON.stringify({ request: { id } }),
    });
  },

  delete: (id: string) => {
    return request('/uoReports/delete', {
      method: 'POST',
      body: JSON.stringify({ request: { id } }),
    });
  },

  export: (id: string, format: 'docx' | 'pdf') => {
    return request(`/uoReports/export/${id}?format=${format}`, { method: 'GET' }, true);
  },
};

export default UoReportService;
